/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgArrowTriangleUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <desc>{'Created with sketchtool.'}</desc>
    <g id='\uD83D\uDEE0\uD83D\uDEE0\uD83D\uDEE0'>
      <g id='Icon/Arrows/Dropdown/Up'>
        <path
          d='M17.8518467,14.0912367 C18.1446228,14.374051 17.9900387,14.7421551 17.5065735,14.9134223 C17.3466626,14.9700703 17.1632806,15 16.9763326,15 L7.02382598,15 C6.45854198,15.0001142 6.00019451,14.7321781 6,14.401548 C6,14.2920085 6.05124907,14.184558 6.14835381,14.0908982 L11.1246071,9.28875923 C11.4172718,9.00590533 12.0465061,8.91539386 12.5300393,9.08659402 C12.6714595,9.13666581 12.7900402,9.20603207 12.8756364,9.28875919 L17.8518467,14.0912367 Z'
          id='Path'
        />
      </g>
    </g>
  </svg>
)
export default SvgArrowTriangleUp
